module.exports = __webpack_public_path__ + "img/icon_bms8.148394c4.jpg";